exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".pill[data-v-51672523] {\n  border-radius: 4px;\n  padding: 0 0.4em;\n  display: inline-block;\n}\n.info[data-v-51672523] {\n  color: #55565a;\n  background-color: #d9e4f3;\n}\n.secondary[data-v-51672523] {\n  color: #55565a;\n  background-color: #f6f5f4;\n}\n.danger[data-v-51672523] {\n  background-color: #f00;\n  color: #fff;\n}\n.light-danger[data-v-51672523] {\n  color: #55565a;\n  background-color: #ffdede;\n}\n.warning[data-v-51672523] {\n  background-color: #ffc107;\n  color: #f6f5f4;\n}\n", ""]);

// exports
